import React, { FC } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { getImageUrl } from "src/utils/getImageUrl";
import { Link } from "../Link";

interface Props {
  path: string;
  image: string;
  alt: string;
  category: string;
}

export const Image: FC<Props> = ({ path, image, category, alt }) => {
  return (
    <div className="relative flex h-48 xs:h-40 md:h-55.75 md:max-w-76 md:min-w-76 w-full ">
      <Link className="flex rounded-20 overflow-hidden w-full" href={path}>
        <LazyLoadImage
          className="w-full h-full object-cover object-center rounded-20 hover:scale-125 !transition-all !duration-200"
          src={getImageUrl(image)}
          alt={alt}
          effect="blur"
          wrapperProps={{
            style: { width: "100%", height: "100%" },
          }}
        />

        <span className="absolute left-3 top-3 bg-purple-base text-white-base px-3 rounded-20">
          {category}
        </span>
      </Link>
    </div>
  );
};
